import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getGroupTitle = (record, translate) =>
  `${translate("resources.group-doc.fields.group_id")} ${record.id} (${
    record.name
  })`;

const Edit = ({ classes, ...props }) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={true}
      title={<DynamicTitleWithTooltip getTitle={getGroupTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
